import {useState,useEffect} from 'react';
import {  Route, Routes, Link, useNavigate } from 'react-router-dom';
import Modal from './Modal'
import scrollIntoView from 'scroll-into-view-if-needed'
const API_ID = process.env.REACT_APP_API_ID; 
const API_TOKEN = process.env.REACT_APP_API_TOKEN;

function Posts() {
    const [posts, setPosts] = useState();
    const [showModal, setShowModal] = useState(false);
    const [activeIndex, setactiveIndex] = useState("");
    const [activeModalData,setactiveModalData] = useState();
    const [disabledNewButton,setdisabledNewButton] =useState(false);
    const [disabledOldButton,setdisabledOldButton] =useState(false);
    const [checkDataLoading, setcheckDataLoading] = useState(false);
    const [numberOfitemsShown,setnumberOfitemsShown] = useState(9);
    const history = useNavigate();
    
    // const ref = useRef();
    useEffect(() => {
      getPosts();
      // console.log('posts',posts,location,'location.pathname.length>1:',location.pathname.length>1)
      // console.log('checkDataLoading',checkDataLoading)
      if(checkDataLoading){
        openModalURL()
      }
      // eslint-disable-next-line
    },[checkDataLoading]);
   
   

    const openModalURL = () => {
      let host = window.location.hostname,
      productionURL = host.indexOf('stuff.co.nz') >= 0,
      regexMatch,
      postId,
      matchingPostIndex;
      // console.log('window.location.pathname',window.location)
      //   console.log('is this logic running?')
        if(productionURL){
          // check data array
          // check url is larger than initial url 
          if(posts.length > 0 && window.location.hash.length > 2 ){
         
          // if(posts.length > 0 && window.location.pathname.length > 2 ){
            // grab what would theoretically be the postId
            regexMatch = window.location.hash.match(/\/(\d+)\//);
            // if there is a regex match
            // console.log('post id is:', regexMatch)
            if (regexMatch) {
            postId = parseInt(regexMatch[1]);
            // find the index of the post object in the data array that matches the postIds
            matchingPostIndex = posts.findIndex(obj => {
              return obj.postId === postId
            })
            // console.log('is this running?')
            updateActiveIndex(matchingPostIndex, "urlTrigger");
            }
          }
          }else{
            // console.log('local url')
            if(posts.length > 0 && window.location.hash.length > 1 ){
            // if (posts.length > 0 && window.location.pathname.length > 1) {
              // grab what would theoretically be the postId
              regexMatch = window.location.hash.match(/\/(\d+)\//);
              // if there is a regex match
              if (regexMatch) {
                // console.log('running?')
                postId = parseInt(regexMatch[1]);
                // find the index of the post object in the data array that matches the postIds
                matchingPostIndex = posts.findIndex(obj => {
                  return obj.postId === postId
                })
                updateActiveIndex(matchingPostIndex, "urlTrigger");
              }
            }
       }
    }
    const toSeoUrl= (url) => { 
      // make the url lowercase         
      var encodedUrl = url.toString().toLowerCase(); 
      // replace & with and      
      // eslint-disable-next-line     
      encodedUrl = encodedUrl.split(/\&+/).join("-and-")
      // remove question mark
        encodedUrl = encodedUrl.replace(/[?=]/g, "");
      // remove blank space in the end 
      encodedUrl = encodedUrl.replace(/\s*$/,"");
      // māori change to maori
      encodedUrl = encodedUrl.replace(/ā+/,"a");
      // remove invalid characters 
      encodedUrl = encodedUrl.split(/[^a-z0-9]/).join("-");       
  
      // remove duplicates 
      encodedUrl = encodedUrl.split(/-+/).join("-");
      // trim leading & trailing characters 
      encodedUrl = encodedUrl.trim('-'); 
  
      return encodedUrl; 
    }
  
    const getPosts = () => {
      // console.log('getPosts function')
      //`https://api.scribblelive.com/v1/stream/${API_ID}/posts?PageSize=100&Token=${API_TOKEN}`
      fetch(`https://interactives.stuff.co.nz/2022/the-whole-truth-te-maramatanga/data/completedPosts.json`)
      .then(res => res.json())
      .then(data => {
        // console.log('data:',data.posts)
        var cleanedData = [],
              dataObject;
          data.posts.forEach((postData, index) => {
            var postContent = postData.Content;
  
            var h1Start = postContent.indexOf('<h1>') + 4,
                h1End = postContent.indexOf('</h1>'),
                title = postContent.substring(h1Start, h1End);
            
            var postBodyStart;   
            if(postContent.indexOf('<h2>') !== -1){
              var h2Start = postContent.indexOf('<h2>') + 4,
              h2End = postContent.indexOf('</h2>'),
              subTitle = postContent.substring(h2Start, h2End);
              postBodyStart = postContent.indexOf('</h2>') + 5;
            }else{
             postBodyStart = postContent.indexOf('</h1>') + 5;
             subTitle = ''
            }    
            var postBodyEnd = postContent.length,
                postBody = postContent.substring(postBodyStart, postBodyEnd);
  
            
            // console.log('postContent:',postContent)
            if(postContent.match(/<img[^>]*\/?>/g)){
              var thumbnailImage = postContent.match(/<img[^>]*\/?>/g)[0],
                  thumbnailStart = thumbnailImage.indexOf('<img alt src="')+14,
                  thumbnailEnd = thumbnailImage.indexOf('>') - 3,
                  thumbnailSrc = thumbnailImage.substring(thumbnailStart, thumbnailEnd);
            }    
            var picByline = postContent.match(/(<iframe\s+src=("[^"]+").*?\s+class="picbyline".*?<\/iframe>)/g)|| postContent.match(/(<iframe\s+class="picbyline".*?<\/iframe>)/g);
           
            // console.log(picByline)
            var label;
             if(!postData.PostMeta.Tags){
              label = "other"
            }else if(postData.PostMeta.Tags.length === 0){
              label = "other"
            }else{
              label = postData.PostMeta.Tags[0]
            };
          
            
            var postId = postData.Id;
  
            var autor = postData.Creator.Name;
            var autorPic = postData.Creator.Avatar;
  
            var seoUrl = toSeoUrl(title);
  
            var creationDate = postData.CreationDate.substring(0,10);
            var publishedDateArr=[],
                monthArr = ["January","February","March","April","May","June","July","August","September","October","November","December"],
                publishdateIOS = new Date(creationDate),
                publsishedDate = publishdateIOS.getUTCDate();
                publishedDateArr.push(publsishedDate);
                publsishedDate = monthArr[publishdateIOS.getUTCMonth()];
                publishedDateArr.push(publsishedDate);
                publsishedDate = publishdateIOS.getUTCFullYear();
                publishedDateArr.push(publsishedDate);
            // console.log('raw data from post:',postData)
            dataObject = {
              "title": title,
              "subTitle": subTitle,
              "seoUrl": seoUrl,
              "label": label,
              "postBody": postBody,
              "postId": postId,
              "autor" : autor,
              "autorPic" : autorPic,
              "creationDate": publishedDateArr.join(' '),
              "index": index,
              "thumbnailSrc": thumbnailSrc,
              "picByline": picByline,
            };
  
            cleanedData.push(dataObject);
          });
       
        setPosts(cleanedData);
        setcheckDataLoading(true);
       
      })
      .catch(err => err);
      };
    
     
    const  updateActiveIndex = (currentIndex, clickedButtonType) => {
       
        if (clickedButtonType === "openModal") {
            setactiveIndex(currentIndex);
            updateActiveModalData(currentIndex);
            updateURLPath(currentIndex);
            checkPostNavButtons(currentIndex);
        } else if (clickedButtonType === "clickNewPost") {
          // as long as the new index is not below 0
          if (currentIndex > 0) {
            setactiveIndex(currentIndex - 1 );
            checkPostNavButtons(currentIndex - 1);
            updateActiveModalData(currentIndex - 1);
            updateURLPath(currentIndex - 1);
          }
        } else if (clickedButtonType === "clickOldPost") {
          // as long as the new index is not greater than highest index available
          if (currentIndex <= posts.length - 1) {
              setactiveIndex(currentIndex + 1 );
              checkPostNavButtons(currentIndex + 1);
              updateActiveModalData(currentIndex + 1);
              updateURLPath(currentIndex + 1);
          }
        } else if (clickedButtonType === "urlTrigger" && currentIndex !== -1) {
          // console.log('prod updater url triggered?')
          setactiveIndex(currentIndex);
          setShowModal(true);
          checkPostNavButtons(currentIndex);
          document.body.classList.add('overflowforbody');
          updateActiveModalData(currentIndex);
          updateURLPath(currentIndex)
        } 
        
    }
    
    const openModal = (index) => {
        updateActiveIndex(index, "openModal");
        setShowModal(true);
        document.body.classList.add('overflowforbody')
    };
    const hideModal = (index) => {
        updateActiveIndex(index, "closeModal");
        setShowModal(false);
        backURLPath();
        document.body.classList.remove('overflowforbody');
    };
    const checkPostNavButtons = (index) => {
        var arrayLength = posts.length;
        var lastIndexInArray = arrayLength - 1;
        // console.log('lastIndexInArray:',lastIndexInArray,'index:',index)
        if (index === 0) {
          if(arrayLength <=1){
              setdisabledNewButton(true)
              setdisabledOldButton(true)
          }else{
            setdisabledNewButton(true)
            setdisabledOldButton(false)
          }
    
        } else if (index === lastIndexInArray) {
            setdisabledNewButton(false)
            setdisabledOldButton(true)
        } else {
            setdisabledNewButton(false)
            setdisabledOldButton(false)
        }

      }
    const updateActiveModalData = (newIndex) => {
        setactiveModalData({
            title: posts[newIndex].title,
            subTitle: posts[newIndex].subTitle,
            seoUrl: posts[newIndex].seoUrl,
            id: newIndex,
            postBody: posts[newIndex].postBody,
            label: posts[newIndex].label,
            autor: posts[newIndex].autor,
            autorPic: posts[newIndex].autorPic,
            picByline: posts[newIndex].picByline,
            creationDate:posts[newIndex].creationDate
          })
    }
    const newPostButton = () => {
        updateActiveIndex(activeIndex, 'clickNewPost');
        // document.querySelector('.modalwrapper--modalbox').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
        scrollIntoView(document.querySelector('.modalwrapper--modalbox'), {
          scrollMode: 'if-needed',
          block: 'start',
          inline: 'nearest',
        })
        // google ad slot distroy
        // var slotArr = window.googletag.pubads().getSlots();
        // console.log('newerpost', slotArr)
        // window.googletag.destroySlots([slotArr[slotArr.length - 1]]); 
      };
    
    const oldPostButton = () => {
        updateActiveIndex(activeIndex, 'clickOldPost');
        // document.querySelector('.modalwrapper--modalbox').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
        scrollIntoView(document.querySelector('.modalwrapper--modalbox'), {
          scrollMode: 'if-needed',
          block: 'start',
          inline: 'nearest',
        })
        // google ad slot distroy
        // var slotArr = window.googletag.pubads().getSlots();
        // console.log('olderpost', slotArr)
        // window.googletag.destroySlots([slotArr[slotArr.length - 1]]); 
      };
    const updateURLPath = (pathIndex) => {
        let host = window.location.hostname,
        productionURL = host.indexOf('stuff.co.nz') >= 0;
        if(productionURL){
          // console.log('prod url',this.state.filteredData[pathIndex].postId)
          history(`/${posts[pathIndex].postId}/${posts[pathIndex].seoUrl}`)
        }else{
          history(`/${posts[pathIndex].postId}/${posts[pathIndex].seoUrl}`)
        }
    };

    const backURLPath = () => {
        let host = window.location.hostname,
        productionURL = host.indexOf('stuff.co.nz') >= 0;
        if(productionURL){
          history('/')
        }else{
          history('/')
        }
      };   
    // Show only 6 posts  
    var showListArr, loadMore;
    if(posts){
  
    showListArr = posts.slice(0, numberOfitemsShown);
    loadMore = () => {
      if (numberOfitemsShown + 6 <= posts.length) {
        setnumberOfitemsShown(numberOfitemsShown+6)
      } else {
        setnumberOfitemsShown(posts.length)
      }
    }
    }

    // Load More
   
  
    return (
        <div className='thumbnail-container'>
           {posts && showListArr.map((item, index)=>(
          <Link
          key={item.postId}
          to={`/${item.postId}/${item.seoUrl}`}
          replace
          onClick={() => openModal(index)}  
          className={`thumbnail-container--eachbox thumbnail-container--eachbox--${item.label.replace(/\s+/g,"")}`}>
            {item.thumbnailSrc && item.label !=="other" && <div className={`thumbnail-container--eachbox---thumbnailbox thumbnail-container--eachbox---thumbnailbox--${item.label.replace(/\s+/g,"")}`} style={{backgroundImage:`url(${item.thumbnailSrc})`}}></div>}
          <div className="thumbnail-container--eachbox---descriptionbox">
            <span className="thumbnail-container--eachbox---descriptionbox--date">{item.creationDate}</span>
            <span className="thumbnail-container--eachbox---descriptionbox--title">{item.title}</span>
            {item.label === "other" && <span className="thumbnail-container--eachbox---descriptionbox--subheading">{item.subTitle}</span>}
          </div>
          <span className="thumbnail-container--eachbox--button">Read More</span>
          </Link>
          ))}
          {posts && showListArr.length !== posts.length ? <button className="thumbnail-container--loadButton" onClick={loadMore}>load more</button> : <></>}
           <Routes>
          <Route
          path="/:postId/:seoUrl"
          element={<Modal 
            showModal={showModal}
            hideModal={hideModal}
            newPostButton={newPostButton} 
            oldPostButton={oldPostButton}
            disabledNewButton={disabledNewButton}
            disabledOldButton={disabledOldButton}
            activeModalData={activeModalData}
          />}
         />
          </Routes>
        </div>
      );
}

export default Posts;